<template>
    <div>
        <div class="move-box-list">
            <div class="move-box" v-for="(item, index) of mobiles" :key="index">
                <div class="img">
                    <img :src="'https://cdntiku.oss-cn-shanghai.aliyuncs.com/h5/heads/' + item.heads + '.png'" />
                </div>
                <span>{{ item.tel }} {{ item.text }}</span>
            </div>
        </div>
        <div class="tips-box" v-show="showTips" v-if="needTips">
            <div class="tips">
                <div class="service_head"></div>
                TA当前在线，抓住机会畅聊一番吧～
                <!-- <div class="arrow-bottom"></div> -->
            </div>
        </div>

    </div>
</template>

<script setup>
import {
    ref,
    reactive,
    inject,
    defineProps,
    defineExpose,
    onMounted, watch
} from 'vue'
// import sensors from "sa-sdk-javascript";
const sensors = inject('$sensors');
const props = defineProps({
    pageSource: {
        type: Number,
        default: null
    },
    needTips: {
        type: Boolean,
        default: false
    },
    mapId: {
        type: Number,
        default: 30094
    }
});

watch(() => props.needTips, (newVal) => {
    console.log('newVal', newVal)
    needTips.value = newVal
})

const needTips = ref(props.needTips);
const isAction = ref(false)
const showTips = ref(false)//是否展示提示
const mobiles = reactive(
    [{
        tel: "13******168",
        text: "1分钟前咨询了课程"
    },
    {
        tel: "13******380",
        text: "1分钟前咨询了课程"
    },
    {
        tel: "15******286",
        text: "3分钟前咨询了课程"
    },
    {
        tel: "18******698",
        text: "4分钟前咨询了课程"
    },
    {
        tel: "13******387",
        text: "5分钟前咨询了课程"
    },
    {
        tel: "13******462",
        text: "7分钟前咨询了课程"
    },
    {
        tel: "18******494",
        text: "8分钟前咨询了课程"
    },
    {
        tel: "15******173",
        text: "8分钟前咨询了课程"
    },
    {
        tel: "13******327",
        text: "9分钟前咨询了课程"
    },
    {
        tel: "13******453",
        text: "10分钟前咨询了课程"
    },
    {
        tel: "18******223",
        text: "12分钟前咨询了课程"
    },
    {
        tel: "13******153",
        text: "13分钟前咨询了课程"
    },
    {
        tel: "18******948",
        text: "13分钟前咨询了课程"
    },
    {
        tel: "18******523",
        text: "14分钟前咨询了课程"
    },
    {
        tel: "13******169",
        text: "15分钟前咨询了课程"
    },
    {
        tel: "13******452",
        text: "17分钟前咨询了课程"
    },
    {
        tel: "15******932",
        text: "18分钟前咨询了课程"
    },
    {
        tel: "18******488",
        text: "20分钟前咨询了课程"
    },
    {
        tel: "13******834",
        text: "20分钟前咨询了课程"
    },
    {
        tel: "13******113",
        text: "21分钟前咨询了课程"
    }
    ]
);
onMounted(() => {
    //20个随机头像
    mobiles.forEach(item => {
        item.heads = Math.floor(Math.random() * (1 - 20) + 20);
    })
    //10秒倒讲时
    if (needTips.value) {
        setTimeout(() => {
            if (!isAction.value) {
                showTips.value = true;
                sensors.track("page_icon_exposure", {
                    map_id: props.mapId,
                    page_source: props.pageSource
                });
            }
        }, 3000);
    }
});

const checkAction = () => {
    isAction.value = true
}
defineExpose({
    checkAction
})
</script>

<style lang="less">
.move-box-list {
    position: fixed;
    top: 0.94rem;
    z-index: 100;
    height: 2.25rem;
    width: 370rem;
    left: 0;
    box-sizing: border-box;
}

.move-box {
    height: 2.25rem;
    background: linear-gradient(90deg,
            rgba(0, 0, 0, 0.4) 0%,
            rgba(0, 0, 0, 0.3) 55%,
            rgba(0, 0, 0, 0) 100%);
    border-radius: 1.13rem;
    margin-right: 1.5rem;
    z-index: 100;
    padding: 0 0.63rem 0 0.5rem;
    display: inline-block;
    font-size: 0.88rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 2.25rem;
    animation: rotation 50s infinite linear;
    -webkit-animation: rotation 50s infinite linear;
    box-sizing: border-box;
    /* Safari 和 Chrome */
}

@keyframes rotation {
    0% {
        transform: translateX(calc(100vw)) translateY(0);
    }

    100% {
        transform: translateX(-370rem) translateY(0);
    }
}

@-webkit-keyframes rotation {
    0% {
        transform: translateX(calc(100vw)) translateY(0);
    }

    100% {
        transform: translateX(-370rem) translateY(0);
    }
}

@-moz-keyframes rotation {
    0% {
        transform: translateX(calc(100vw)) translateY(0);
    }

    100% {
        transform: translateX(-370rem) translateY(0);
    }
}

.move-box .img {
    width: 1.5rem;
    height: 1.5rem;
    border: 0.13rem solid #ffffff;
    display: inline-block;
    border-radius: 50%;
    overflow: hidden;
    position: absolute;
    top: 0.25rem;
}

.move-box .img img {
    width: 100%;
    height: 100%;
}

.move-box span {
    margin-left: 2.5rem;
}

.tips-box {
    height: 3.08rem;
    position: fixed;
    z-index: 101;
    width: 100%;
    bottom: 5.63rem;
}

.tips {
    width: 17.5rem;
    height: 2.54rem;
    position: absolute;
    right: 0;
    top: 0;
    background: #ffffff;
    border: 0.04rem solid #FFFFFF;
    border-radius: 0 3.85rem 3.85rem 0;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 0.92rem;
    color: #333333;
    display: flex;
    align-items: center;
    justify-content: center;

    .service_head {
        width: 3.08rem;
        height: 3.08rem;
        background: url(../assets/images/backToNative/head.png) no-repeat;
        background-size: 100%;
        margin-right: 0.69rem;
        position: absolute;
        top: -0.27rem;
        left: -2rem;
    }
}

.tips .text-bold {
    font-size: 0.88rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    position: absolute;
    top: 0.69rem;
    left: 4.75rem;
    box-sizing: border-box;
}

.tips .text-small {
    font-size: 0.75rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #dfe1e7;
    position: absolute;
    bottom: 0.69rem;
    left: 4.75rem;
    box-sizing: border-box;
}

.arrow-bottom {
    position: absolute;
    background: url(../assets/images/arrow-bottom.png) no-repeat;
    background-size: 100%;
    width: 1.06rem;
    height: 0.5rem;
    right: 3.75rem;
    bottom: -0.5rem;
}

.tips .close {
    position: absolute;
    background: url(../assets/images/tip-close.png) no-repeat;
    background-size: 100%;
    width: 1.25rem;
    height: 1.25rem;
    right: 0.38rem;
    top: 0.38rem;
}

.tip-img {
    width: 3.88rem;
    display: inline-block;
}
</style>
